/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_1_QInputs */

const en_vc_faq_1_q = /** @type {(inputs: Vc_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is VectorCraft free?`)
};

const zh_vc_faq_1_q = /** @type {(inputs: Vc_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 免费吗？`)
};

/**
* | output |
* | --- |
* | "Is VectorCraft free?" |
*
* @param {Vc_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_1_q = /** @type {((inputs?: Vc_Faq_1_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_1_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_1_q(inputs)
	return zh_vc_faq_1_q(inputs)
});
export { vc_faq_1_q as "vc.faq.1.q" }